import { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { FiClock } from 'react-icons/fi';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [isLoading, setIsLoading] = useState(false);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formDataObj = new FormData();
    formDataObj.append('access_key', '0de206ed-3783-4a54-991a-3b394384a418'); // Replace with your actual key
    formDataObj.append('name', formData.name);
    formDataObj.append('email', formData.email);
    formDataObj.append('phone', formData.phone);
    formDataObj.append('message', formData.message);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataObj,
      });

      const data = await response.json();

      if (data.success) {
        alert('Message sent successfully!');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        console.error('Error:', data);
        alert('Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (

    <div>
    
    <section className="bg-white py-16">
  <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 px-6 items-center">

    {/* Left Image Section */}
    <div className="relative">
      <img
        src="https://images.unsplash.com/photo-1501004318641-b39e6451bec6" 
        alt="Beautiful flower pot"
        className="rounded-3xl shadow-xl w-full h-[500px] object-cover"
      />
      <div className="absolute bottom-4 left-4 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-xl text-sm text-green-800 font-semibold">
        Let Nature Connect Us 🌿
      </div>
    </div>

    {/* Right Form Section */}
    <div>
      <h2 className="text-4xl font-bold text-green-800 mb-4">Contact Us</h2>
      <p className="text-gray-600 mb-6">Have questions or just want to say hi? We’d love to hear from you!</p>
      
      <form onSubmit={handleSubmit} className="space-y-5">
  {/* Name */}
  <div>
    <label className="block text-sm font-medium text-gray-700">Name</label>
    <input
      type="text"
      name="name"
      value={formData.name}
      onChange={handleChange}
      required
      className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-green-500"
      placeholder="Enter your name"
    />
  </div>

  {/* Email */}
  <div>
    <label className="block text-sm font-medium text-gray-700">Email</label>
    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      required
      className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-green-500"
      placeholder="Enter your email"
    />
  </div>

  {/* Phone */}
  <div>
    <label className="block text-sm font-medium text-gray-700">Phone Number</label>
    <input
      type="tel"
      name="phone"
      value={formData.phone}
      onChange={handleChange}
      required
      pattern="[0-9]{10}"
      className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-green-500"
      placeholder="Enter your phone number"
    />
  </div>

  {/* Message */}
  <div>
    <label className="block text-sm font-medium text-gray-700">Message</label>
    <textarea
      name="message"
      value={formData.message}
      onChange={handleChange}
      required
      rows={4}
      className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-green-500"
      placeholder="Enter your message"
    ></textarea>
  </div>

  {/* Submit Button */}
  <div>
    <button
      type="submit"
      disabled={isLoading}
      className={`bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition ${
        isLoading ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      {isLoading ? 'Sending...' : 'Send Message'}
    </button>
  </div>
</form>


    </div>
  </div>
</section>


  {/* Google Maps */}
      <div className="my-12 flex justify-center ">
          <iframe
            className="w-full lg:w-[930px] h-[300px] sm:h-[450px] rounded-md"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.8186943396313!2d88.3507341!3d22.548463499999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027710fe7094cb%3A0xefcbdbde655df7bd!2s6%2C%20Little%20Russel%20St%2C%20Kankaria%20Estates%2C%20Park%20Street%20area%2C%20Kolkata%2C%20West%20Bengal%20700071!5e0!3m2!1sen!2sin!4v1729073713648!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
</div>
  );
};

export default ContactUs;
